var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBelivers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 13,
    y: -1,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 27,
    y: 13,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: -1,
    y: 13,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 13,
    y: 27,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 15.293 17.707)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 14,
    y: -0.828,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 28.828,
    y: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: -0.828,
    y: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 14,
    y: 28.828,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.693 25.974v-6.36h2.359L20.5 17h-2.807v-1.463c0-.72.22-1.212 1.357-1.212h1.45v-2.227A21.32 21.32 0 0 0 18.387 12c-2.091 0-3.522 1.16-3.522 3.29V17H12.5v2.614h2.365v6.131a9 9 0 1 1 2.828.229z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelivers);
export default __webpack_public_path__ + "static/media/belivers.e951a65b8479fe15783dcd3a35a83e2a.svg";
export { ForwardRef as ReactComponent };